import { useIntl } from 'react-intl';

const MAX_SALARY = 200000;

type SalaryWithCap = (value: number, currency: string) => string;

export const useSalaryWithCap = (): SalaryWithCap => {
  const intl = useIntl();

  return (value: number, currency: string) => {
    if (value >= MAX_SALARY) {
      const formatted = intl.formatNumber(value, {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
      });

      // Replace the cap number with "cap+" (locale-aware)
      const numberPart = intl.formatNumber(value, { maximumFractionDigits: 0 });
      return formatted.replace(numberPart, `${numberPart}+`);
    }

    return intl.formatNumber(value, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    });
  };
};
